import vTooltip from '~/directives/vTooltip';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', vTooltip);
});